@switch (data.tipo) {
  @case ('error') {
    <div class="flex flex-col items-center text-center">
      <span class="material-symbols-rounded ui-dialog-icon text-beech">gpp_maybe</span>
      <h2 class="mt-3 text-2xl font-extrabold">Ups</h2>
      <p class="mt-2 text-sm text-beech-muted" [innerHTML]="data.message"></p>
      <button type="button" class="ui-btn ui-btn-primary mt-6" (click)="_dialog.close()">Cerrar</button>
    </div>
  }
  @case ('success') {
    <div class="flex flex-col items-center text-center">
      <span class="material-symbols-rounded ui-dialog-icon text-ok">check_circle</span>
      <h2 class="mt-3 text-2xl font-extrabold">Listo</h2>
      <p class="mt-2 text-sm text-beech-muted">{{ data.message }}</p>
      <button type="button" class="ui-btn ui-btn-primary mt-6" (click)="_dialog.close()">Cerrar</button>
    </div>
  }
  @case ('warning') {
    <div class="flex flex-col items-center text-center">
      <span class="material-symbols-rounded ui-dialog-icon text-warn">warning</span>
      <h2 class="mt-3 text-2xl font-extrabold">Atención</h2>
      <p class="mt-2 text-sm text-beech-muted">{{ data.message }}</p>
      <div class="mt-6 flex gap-2">
        <button type="button" class="ui-btn ui-btn-secondary" (click)="_dialog.close()">No</button>
        <button type="button" class="ui-btn ui-btn-primary" (click)="_dialog.close(true)">Sí</button>
      </div>
    </div>
  }
  @case ('more_info') {
    <div class="text-sm text-ink" [innerHTML]="data.message"></div>
    <div class="mt-4 flex justify-end">
      <button type="button" class="ui-btn ui-btn-primary" (click)="_dialog.close()">Cerrar</button>
    </div>
  }
  @case ('generate_payment') {
    <div class="flex flex-col items-center text-center">
      <span class="material-symbols-rounded ui-dialog-icon text-beech">payments</span>
      <h2 class="mt-3 text-2xl font-extrabold">Generando pago</h2>
      <p class="mt-3 flex items-center gap-2 text-sm text-beech-muted">
        <span class="h-4 w-4 animate-spin rounded-full border-2 border-beech border-t-transparent"></span>
        Procesando…
      </p>
    </div>
  }
}
